import React from "react";
import PropTypes from "prop-types";
import { sendCustomGaEvents } from "../../../tracking";
import { Button } from "@cars24/turbo-web/lib/button";
import LazyImage from "../../shared/lazy-image";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { Label } from "@cars24/turbo-web/lib/label";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { NUMBER } from "../../../constants/app-constants";
import styles from "./styles.css";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const RtoVehInfoBlogs = ({
    blogList,
    pageType
}) => {
    const { tokens } = useTokens();
    const handleGaEvent = async () => {
        await yieldToMain();
        sendCustomGaEvents({
            event: "blogs_click",
            eventAction: "recent_blogs_clkicked",
            eventCategory: `RTOPage_${pageType}`
        });
    };

    return (
        blogList && !!blogList.length &&
        <div styleName={"styles.blogWrapper"}>
            <Heading level={NUMBER.FOUR} >Recent blogs</Heading>
            <div styleName={"styles.blogCardWrapper"}>
                {blogList.map((item, index) => (
                    <a
                        key={`blogs_${index}`}
                        href={item.link}
                        onClick={handleGaEvent}
                    >
                        <div styleName={"styles.imgCard"}>
                            <LazyImage src={item.imgSrc} alt={item.altTag} />
                        </div>
                        <div styleName={"styles.blogCardText"}>
                            <Label level={NUMBER.THREE} color={tokens.text_default_text_primary} fontWeight="semibold">{item.titleRendered}</Label>
                            <Button
                                label="Read more"
                                size="medium"
                                variant="secondary"
                            />
                        </div>

                    </a>
                ))}
            </div>
        </div>
    );
};

RtoVehInfoBlogs.propTypes = {
    blogList: PropTypes.array,
    pageType: PropTypes.string
};

export default RtoVehInfoBlogs;
